export default "__VITE_ASSET__BKVScOKt__"